import styled from 'styled-components';

import getContrastTextColor from '../../utils/common/getContrastTextColor';

interface BadgeContainerProps {
  $color: string;
}

const BadgeContainer = styled.div<BadgeContainerProps>`
  width: 32px;
  height: 24px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background-color: ${({ $color }) => $color};
  color: ${({ $color }) => getContrastTextColor($color)};
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
`;

export { BadgeContainer };
